module.exports = __WEBPACK_EXTERNAL_MODULE_38__;


//////////////////
// WEBPACK FOOTER
// external "fenix-ui-menu"
// module id = 38
// module chunks = 0